import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ApiService } from '../services/api.service';
import { SocioEmotionalSkill } from '../socio-emotional-skills-test/socio-emotional-skills-test.models';
import { SocioEmotionalSkillTestResult } from './socio-emotional-skills-test-results.models';

const SOCIO_EMOTIONAL_SKILLS_ENDPOINT = 'api/socioEmotionalSkills';
const SOCIO_EMOTIONAL_SKILLS_TEST_RESULTS_ENDPOINT = 'api/socioEmotionalSkillTestResult/student/lastThree';

@Component({
  selector: 'app-socio-emotional-skills-test-results',
  templateUrl: './socio-emotional-skills-test-results.component.html',
  styleUrls: ['./socio-emotional-skills-test-results.component.scss']
})
export class SocioEmotionalSkillsTestResultsComponent implements OnInit {
  socioEmotionalSkills: SocioEmotionalSkill[] = [];
  generalSocioEmotionalSkill: SocioEmotionalSkill;

  socioEmotionalSkillsTestResults: SocioEmotionalSkillTestResult[] = [];
  lastSocioEmotionalSkillsTestResult: SocioEmotionalSkillTestResult;

  isLoading = false;

  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;

    forkJoin({
      skills: this.apiService.get({ api: SOCIO_EMOTIONAL_SKILLS_ENDPOINT }),
      testResults: this.apiService.get({ api: SOCIO_EMOTIONAL_SKILLS_TEST_RESULTS_ENDPOINT })
    }).subscribe(
      ({ skills, testResults }: {skills:SocioEmotionalSkill[], testResults:SocioEmotionalSkillTestResult[]}) => {

        this.socioEmotionalSkills = skills.filter(skill => !skill.isGeneral);
        this.generalSocioEmotionalSkill = skills.find(skill => skill.isGeneral);
        
        this.socioEmotionalSkillsTestResults = testResults;
        this.lastSocioEmotionalSkillsTestResult = testResults[0];

        this.isLoading = false;
      },
      (error) => {
        console.error('Error loading data:', error);
        this.isLoading = false;
      }
    );
  }
}